import AWS from 'aws-sdk';
import config from './config';

const configAWSSDK = () => {
  AWS.config.update({ ...config.aws });
  return AWS;
};

export default configAWSSDK;
